import apiTrainingsTemplate from '@/api/trainings-template'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteTrainingTemplateStart:
    '[delete training template] Delete training template start',
  deleteTrainingTemplateSuccess:
    '[delete training template] Delete training template success',
  deleteTrainingTemplateFailure:
    '[delete training template] Delete training template failure'
}

export const actionTypes = {
  deleteTrainingTemplate: '[delete training template] Delete training template'
}

const mutations = {
  [mutationTypes.deleteTrainingTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteTrainingTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteTrainingTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteTrainingTemplate](context, {id}) {
    context.commit(mutationTypes.deleteTrainingTemplateStart)
    return new Promise(resolve => {
      apiTrainingsTemplate
        .deleteTrainingTemplate(id)
        .then(response => {
          context.commit(mutationTypes.deleteTrainingTemplateSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteTrainingTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
